import { createFileRoute } from '@tanstack/react-router';
import type { Id } from '@aeon-karaoke/cloud-convex/_generated/dataModel';
import { PacksEditorPage } from '@/page/admin/PacksEditorPage';

export const Route = createFileRoute('/_app/admin/packs/$packId')({
  params: { parse: ({ packId }) => ({ packId: packId as Id<'packs'> }) },
  component: PacksEditorRoute,
});

function PacksEditorRoute() {
  const { packId } = Route.useParams();
  return <PacksEditorPage packId={packId} />;
}
